import type MapBrowserEvent from 'ol/MapBrowserEvent';
import type Map from 'ol/Map';
import PointerInteraction from 'ol/interaction/Pointer';

/**
 * «Mover etiqueta en el mapa» (Apariencia, V1.8): an explicit mode in which a drag on the map (mouse or touch) reports
 * its displacement in screen pixels — the label's offset — instead of panning. Nothing geographic is created or moved:
 * the object's point or route stays where it is. Only active while the mode is on.
 */
export class LabelDragInteraction {
  private readonly interaction: PointerInteraction;
  private start: [number, number] | null = null;
  private onDrag: ((dx: number, dy: number, done: boolean) => void) | null = null;

  constructor(private readonly map: Map) {
    this.interaction = new PointerInteraction({
      handleDownEvent: (event: MapBrowserEvent) => { if (!this.onDrag) return false; this.start = [event.pixel[0]!, event.pixel[1]!]; return true; },
      handleDragEvent: (event: MapBrowserEvent) => { if (this.start) this.onDrag?.(event.pixel[0]! - this.start[0], event.pixel[1]! - this.start[1], false); },
      handleUpEvent: (event: MapBrowserEvent) => { if (this.start) this.onDrag?.(event.pixel[0]! - this.start[0], event.pixel[1]! - this.start[1], true); this.start = null; return false; },
    });
    this.interaction.setActive(false);
    map.addInteraction(this.interaction);
  }

  get active(): boolean { return Boolean(this.onDrag); }

  /** Starts the mode with a drag callback, or ends it (null). The cursor shows that the map now moves the label. */
  set(onDrag: ((dx: number, dy: number, done: boolean) => void) | null): void {
    this.onDrag = onDrag; this.start = null;
    this.interaction.setActive(Boolean(onDrag));
    this.map.getTargetElement()?.classList.toggle('label-drag-mode', Boolean(onDrag));
  }
}
